export const downloadCurrentTemplate = (url: string, filename: string) => {
  const anchor = document.createElement('a');
  anchor.download = filename;
  anchor.href = url;
  anchor.click();
};
